// Module
var code = "<div ui-view class=gz-view-container layout=column layout-fill style=overflow:hidden> <malfunction-message-directive></malfunction-message-directive> <ecommerce-upper-ribbon-directive callback=vm.ecommerceCallback></ecommerce-upper-ribbon-directive> <assets-managements-directive is-dialog=false></assets-managements-directive> </div> ";
// Exports
module.exports = code;